import { NgModule } from 'ng-metadata/core';
import {PrmChaptersAndReviews} from "./chaptersAndReviews.directive";
import {ChaptersAndReviewsService} from "./chaptersAndReviews.service";
import {PrmChaptersAndReviewsItem} from "./chaptersAndReviewsItem.directive";
import {ChaptersAndReviewsItemService} from "./chaptersAndReviewsItem.service";


@NgModule({
    declarations: [
        PrmChaptersAndReviews,
        PrmChaptersAndReviewsItem
    ],
    providers: [
        ChaptersAndReviewsService,
        ChaptersAndReviewsItemService
    ],
    imports:[
        'angular-inview'
    ]
})
export class ChaptersAndReviewsModule {}




// WEBPACK FOOTER //
// ./src/main/webapp/components/search/chaptersAndReviews/chaptersAndReviews.module.ts